import { useInfiniteQuery } from '@tanstack/react-query';
import { TGetAdminsParams } from '../../types/admin-management/admin-types';
import { getAdmins } from '../../services/adminService';

// import { cardsService } from '../services/cards-service';

const useGetAdmins = (param: TGetAdminsParams, enabled = true) => {
    // const {} = param;
    const {
        data,
        error,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        status,
        isError,
        refetch,
    } = useInfiniteQuery({
        queryKey: ['get-admins', param],
        queryFn: async ({ pageParam = '' }) =>
            getAdmins({ next_cursor: pageParam, ...param }),
        getNextPageParam: (lastPage) => lastPage?.next_cursor,
        initialPageParam: '',
        // select: (data) => data?.pages.flatMap((page) => page?.admin_users),
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        enabled,
    });
    return {
        data,
        error,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        isLoading: isFetching,
        status,
        isError,
        refetch,
    };
};

export default useGetAdmins;
